import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
  useParams,
  useLocation
} from "react-router-dom";
import SideMenu from "../SideMenu";
import UnitDetailMaster from "./storeDirectory/UnitDetailMaster";
import "bootstrap/dist/css/bootstrap.min.css";
import styles from "./master.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserCircle,
  faSignOutAlt,
  faSitemap,
  faCog,
  faCogs,
} from "@fortawesome/free-solid-svg-icons";
import OccupierMaster from "./occupier/OccupierMaster";
import OccupierCompanyDetails from "./occupier/OccupierCompanyDetails";
import OccupierContactDetails from "./occupier/OccupierContactDetails";
import LandLordMaster from "./landlordDirectory/LandLordMaster";
import LandlordCompanyDetails from "./landlordDirectory/LandlordCompanyDetails";
import LandlordContactDetails from "./landlordDirectory/LandlordContactDetails";
import LandlordBankDetails from "./landlordDirectory/LandlordBankDetails";
import BrokerMaster from "./brokerDirectory/LandLordMaster";
import BrokerCompanyDetails from "./brokerDirectory/LandlordCompanyDetails";
import BrokerContactDetails from "./brokerDirectory/LandlordContactDetails";

import OccupierBrand from "./brandDirectory/OccupierBrand";
import ClientDetail from "./clientDirectory/ClientProfile";
import ClientAccessSetup from "./clientDirectory/ClientAccess";
import DemographicDetail from "./storeDirectory/DemographicDetail";
import AssetDetail from "./storeDirectory/AssetDetail";
import UtilityCharges from "./chargesMaster/UtilityCharges";
import OtherCharges from "./chargesMaster/OtherCharges";
import PropertyTaxLogic from "./logicMaster/PropertyTaxLogic";
import MarketingFundLogic from "./logicMaster/MarketingFundLogic";
import CamLogic from "./logicMaster/CamLogic";
import RentLogic from "./logicMaster/RentLogic";
import ComplianceComponent from "./complianceDirectory/ComplianceComponent";
import CommercialClauses from "./clausesMaster/CommercialClauses";
import TaxationMaster from "./taxation/List";
import LegalClauses from "./clausesMaster/LegalClauses";
import ProductMaster from "./brandDirectory/ProductMaster";
import TopHeader from "../layout/TopHeader";
import { isLogin } from "../utils";

import BudgetMaster from "./budget/BudgetMaster";
import ProspectMaster from "./prospect/ProspectMaster";

import { hasAccess } from "../utils/index";
import { clientAccess } from "../utils/index";
import ProtectedRoute from "../utils/ProtectedRoute";
import BreadcrumbsPage from "./BreadcrumbsPage";
import Import from "./import/Import";

export default function Masters() {
  let match = useRouteMatch();
  let location = useLocation();
  const parts = location.pathname.split('/');
  let urlArray = {
    'client-profile':{'openMenu':'1', 'activeKey':'1-1'},
    'client-access-setup':{'openMenu':'1', 'activeKey':'1-2'},
    'asset-detail':{'openMenu':'2', 'activeKey':'2-1'},
    'unit-detail':{'openMenu':'2', 'activeKey':'2-2'},
    'landlord-company-details':{'openMenu':'3', 'activeKey':'3-1'},
    'landlord':{'openMenu':'3', 'activeKey':'3-2'},
    'landlord-contact-details':{'openMenu':'3', 'activeKey':'3-3'},
    'landlord-bank-details':{'openMenu':'3', 'activeKey':'3-4'},
    'occupier-company-details':{'openMenu':'4', 'activeKey':'4-1'},
    'occupier':{'openMenu':'4', 'activeKey':'4-2'},
    'occupier-contact-details':{'openMenu':'4', 'activeKey':'4-3'},
    'brand-details':{'openMenu':'5', 'activeKey':'5-1'},
    'product-master':{'openMenu':'5', 'activeKey':'5-2'},
    'rent-logic':{'openMenu':'6', 'activeKey':'6-1'},
    'cam-logic':{'openMenu':'6', 'activeKey':'6-2'},
    'property-tax':{'openMenu':'6', 'activeKey':'6-3'},
    'marketing-fund-logic':{'openMenu':'6', 'activeKey':'6-4'},
    'utility-charges':{'openMenu':'7', 'activeKey':'7-1'},
    'other-charges':{'openMenu':'7', 'activeKey':'7-2'},
    'commercial-clauses':{'openMenu':'8', 'activeKey':'8-1'},
    'legal-clauses':{'openMenu':'8', 'activeKey':'8-2'},
    'compliance':{'openMenu':'8', 'activeKey':'8-3'},
    'taxation':{'openMenu':'9', 'activeKey':'9-1'},
    'broker-company-details':{'openMenu':'10', 'activeKey':'10-1'},
    'broker':{'openMenu':'10', 'activeKey':'10-2'},
    'broker-contact-details':{'openMenu':'10', 'activeKey':'10-3'},
    'budget':{'openMenu':'11', 'activeKey':'11-1'},
    'prospect':{'openMenu':'12', 'activeKey':'12-1'},
    
  };

  let openMenu = urlArray[parts[2]]?.openMenu ?? '1';
  //let activeKey = !urlArray[parts[2]] && !clientAccess() ? '1-2' : '1-1';
  let activeKey =  urlArray[parts[2]]?.activeKey ?? (!clientAccess() ? '1-2' : '1-1');

  return (
    <div>
      <TopHeader />
      <div className="masterContainer">
        <div className="masterClassMain mt-4">
          <SideMenu openMenu={openMenu} activeKey={activeKey}  />
          <Switch>
            {clientAccess() && (
              <Route path={`${match.path}/client-profile/:id`}>
                <ClientDetail />
              </Route>
            )}
            {clientAccess() && (
              <Route path={`${match.path}/client-profile`}>
                <ClientDetail />
              </Route>
            )}
            <Route path={`${match.path}/client-access-setup/:id`}>
              <ClientAccessSetup />
            </Route>
            <Route path={`${match.path}/client-access-setup`}>
              <ClientAccessSetup />
            </Route>

            <Route path={`${match.path}/demographic-detail`}>
              <DemographicDetail />
            </Route>

            <Route path={`${match.path}/asset-detail/:id`}>
              <AssetDetail />
            </Route>

            <Route path={`${match.path}/asset-detail`}>
              <AssetDetail />
            </Route>
            {/* <Route path={`${match.path}/tower-detail/:id`}>
            <TowerDetail />
          </Route>

          <Route path={`${match.path}/tower-detail`}>
            <TowerDetail />
          </Route> */}

            <Route path={`${match.path}/unit-detail/:id`}>
              <UnitDetailMaster />
            </Route>

            <Route path={`${match.path}/unit-detail`}>
              <UnitDetailMaster />
            </Route>

            <Route path={`${match.path}/occupier/:id`}>
              <OccupierMaster />
            </Route>

            <Route path={`${match.path}/occupier`}>
              <OccupierMaster />
            </Route>

            <Route path={`${match.path}/occupier-company-details/:id`}>
              <OccupierCompanyDetails />
            </Route>

            <Route path={`${match.path}/occupier-company-details`}>
              <OccupierCompanyDetails />
            </Route>

            <Route path={`${match.path}/occupier-contact-details/:id`}>
              <OccupierContactDetails />
            </Route>

            <Route path={`${match.path}/occupier-contact-details`}>
              <OccupierContactDetails />
            </Route>

            <Route path={`${match.path}/brand-details/:id`}>
              <OccupierBrand />
            </Route>

            <Route path={`${match.path}/brand-details`}>
              <OccupierBrand />
            </Route>

            <Route path={`${match.path}/product-master/:id`}>
              <ProductMaster />
            </Route>

            <Route path={`${match.path}/product-master`}>
              <ProductMaster />
            </Route>

            <Route path={`${match.path}/landlord/:id`}>
              <LandLordMaster />
            </Route>

            <Route path={`${match.path}/landlord`}>
              <LandLordMaster />
            </Route>

            <Route path={`${match.path}/landlord-company-details/:id`}>
              <LandlordCompanyDetails />
            </Route>

            <Route path={`${match.path}/landlord-company-details`}>
              <LandlordCompanyDetails />
            </Route>

            <Route path={`${match.path}/landlord-contact-details/:id`}>
              <LandlordContactDetails />
            </Route>

            <Route path={`${match.path}/landlord-contact-details`}>
              <LandlordContactDetails />
            </Route>

            <Route path={`${match.path}/landlord-bank-details/:id`}>
              <LandlordBankDetails />
            </Route>

            <Route path={`${match.path}/landlord-bank-details`}>
              <LandlordBankDetails />
            </Route>

            <Route path={`${match.path}/broker/:id`}>
              <BrokerMaster />
            </Route>

            <Route path={`${match.path}/broker`}>
              <BrokerMaster />
            </Route>

            <Route path={`${match.path}/broker-company-details/:id`}>
              <BrokerCompanyDetails />
            </Route>

            <Route path={`${match.path}/broker-company-details`}>
              <BrokerCompanyDetails />
            </Route>

            <Route path={`${match.path}/broker-contact-details/:id`}>
              <BrokerContactDetails />
            </Route>

            <Route path={`${match.path}/broker-contact-details`}>
              <BrokerContactDetails />
            </Route>

            {clientAccess() && (
              <Route path={`${match.path}/utility-charges/:id`}>
                <UtilityCharges />
              </Route>
            )}

            {clientAccess() && (
              <Route path={`${match.path}/utility-charges`}>
                <UtilityCharges />
              </Route>
            )}

            {clientAccess() && (
              <Route path={`${match.path}/other-charges/:id`}>
                <OtherCharges />
              </Route>
            )}

            {clientAccess() && (
              <Route path={`${match.path}/other-charges`}>
                <OtherCharges />
              </Route>
            )}

            {clientAccess() && (
              <Route path={`${match.path}/property-tax/:id`}>
                <PropertyTaxLogic />
              </Route>
            )}

            {clientAccess() && (
              <Route path={`${match.path}/property-tax`}>
                <PropertyTaxLogic />
              </Route>
            )}

            {clientAccess() && (
              <Route path={`${match.path}/rent-logic/:id`}>
                <RentLogic />
              </Route>
            )}

            {clientAccess() && (
              <Route path={`${match.path}/rent-logic`}>
                <RentLogic />
              </Route>
            )}

            <Route path={`${match.path}/compliance/:id`}>
              <ComplianceComponent />
            </Route>

            <Route path={`${match.path}/compliance`}>
              <ComplianceComponent />
            </Route>

            {clientAccess() && (
              <Route path={`${match.path}/marketing-fund-logic/:id`}>
                <MarketingFundLogic />
              </Route>
            )}

            {clientAccess() && (
              <Route path={`${match.path}/marketing-fund-logic`}>
                <MarketingFundLogic />
              </Route>
            )}

            {clientAccess() && (
              <Route path={`${match.path}/cam-logic/:id`}>
                <CamLogic />
              </Route>
            )}

            {clientAccess() && (
              <Route path={`${match.path}/cam-logic`}>
                <CamLogic />
              </Route>
            )}

            <Route path={`${match.path}/commercial-clauses/:id`}>
              <CommercialClauses />
            </Route>

            <Route path={`${match.path}/commercial-clauses`}>
              <CommercialClauses />
            </Route>

            <Route path={`${match.path}/taxation/:id`}>
              <TaxationMaster />
            </Route>

            <Route path={`${match.path}/taxation`}>
              <TaxationMaster />
            </Route>

            <Route path={`${match.path}/import`}>
              <Import />
            </Route>

            <Route path={`${match.path}/legal-clauses/:id`}>
              <LegalClauses />
            </Route>

            <Route path={`${match.path}/legal-clauses`}>
              <LegalClauses />
            </Route>

            <Route path={`${match.path}/budget/:id`}>
              <BudgetMaster />
            </Route>

            <Route path={`${match.path}/budget`}>
              <BudgetMaster />
            </Route>

            <Route path={`${match.path}/masters/brand-directory`}>
              <BreadcrumbsPage />
            </Route>
            <Route path={`${match.path}/masters/client-directory`}>
              <BreadcrumbsPage />
            </Route>
            <Route path={`${match.path}/masters/unit-directory`}>
              <BreadcrumbsPage />
            </Route>
            <Route path={`${match.path}/masters/landlord-directory`}>
              <BreadcrumbsPage />
            </Route>
            <Route path={`${match.path}/masters/occupier-directory`}>
              <BreadcrumbsPage />
            </Route>
            {clientAccess() && (
              <Route path={`${match.path}/masters/commercial-logic-master`}>
                <BreadcrumbsPage />
              </Route>
            )}
            {clientAccess() && (
              <Route path={`${match.path}/masters/charges-master`}>
                <BreadcrumbsPage />
              </Route>
            )}
            <Route path={`${match.path}/masters/clauses-master`}>
              <BreadcrumbsPage />
            </Route>


            <Route path={`${match.path}/budget`}>
              <BudgetMaster />
            </Route>

            <Route path={`${match.path}/prospect/:id`}>
              <ProspectMaster />
            </Route>

            <Route path={`${match.path}/prospect`}>
              <ProspectMaster />
            </Route>


            <Route path={`${match.path}/masters/brand-directory`}>
              <BreadcrumbsPage />
            </Route>
            <Route path={`${match.path}/masters/client-directory`}>
              <BreadcrumbsPage />
            </Route>
            <Route path={`${match.path}/masters/unit-directory`}>
              <BreadcrumbsPage />
            </Route>
            <Route path={`${match.path}/masters/landlord-directory`}>
              <BreadcrumbsPage />
            </Route>
            <Route path={`${match.path}/masters/occupier-directory`}>
              <BreadcrumbsPage />
            </Route>
            {clientAccess() && (
              <Route path={`${match.path}/masters/commercial-logic-master`}>
                <BreadcrumbsPage />
              </Route>
            )}
            {clientAccess() && (
              <Route path={`${match.path}/masters/charges-master`}>
                <BreadcrumbsPage />
              </Route>
            )}
            <Route path={`${match.path}/masters/clauses-master`}>
              <BreadcrumbsPage />
            </Route>

            <Route path={`${match.path}`}>
              {/* <div className="container">
                <div className="row">
                  <div className="col-lg-12 mt20">
                    <h1 className="text-center">
                      <FontAwesomeIcon icon={faCogs} size="lg" />
                      <span>MASTERS</span>
                    </h1>
                  </div>
                </div>
              </div> */}
              {clientAccess() ? <ClientDetail /> : <ClientAccessSetup />}

            </Route>
          </Switch>
        </div>
      </div>
    </div >
  );
}
